import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormularzFormly } from '@enauka/shared/ui/formly';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface FormDialogOptions {
  title?: string;
  cancelLabel?: string;
  saveLabel?: string;
}
export interface FormDialogResult<T> {
  modal: NgbActiveModal
  model: T
}

@Component({
  selector: 'enauka-form-dialog',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.css']
})
export class FormDialogComponent<T> implements OnInit {
  form: FormularzFormly<T>;
  options: FormDialogOptions = {
    saveLabel: 'Zapisz',
    cancelLabel: 'Anuluj'
  };

  submit = new EventEmitter<FormDialogResult<T>>();

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  initForm(form: FormularzFormly<T>, options?: FormDialogOptions) {
    this.form = form;
    this.options = { ...this.options, ...options };
  }

  zamknij(reason: string) {
    this.modal.dismiss(reason);
  }

  zatwierdz() {
    if (this.form.form.valid) {
      this.submit.emit({
        modal: this.modal,
        model: this.form.model
      });
    }
  }

}
